/** The no-change plan's result for one scored forecast (round-4 findings): how far it moved, and the cell that prints where it ended. */
import type { KpiId } from "@bsim/domain";
import type { RoundReport } from "@bsim/contracts";
import { formatKpi, formatPrintedChange } from "../format";
import { BAND_LABELS } from "../format/labels";
import { NO_CHANGE_DEFINITION, TWIN_DEFINITION } from "@gxs/metric-defs";

type ForecastRow = RoundReport["forecastErrors"][number];

/** Where the no-change plan ended less where it started the year: the signed move the call is graded against. */
export const noChangeMove = (row: Pick<ForecastRow, "twinActual" | "noChangeBaseline">): number => row.twinActual - row.noChangeBaseline;

/** "A little up (+4bp)" for a band call, "3.82% (+5bp)" for a numeric one. */
export function noChangeCell(row: ForecastRow): string {
  const kpi = row.kpi as KpiId;
  const move = formatPrintedChange(kpi, noChangeMove(row));
  return row.format === "band" ? `${BAND_LABELS[row.actualBand]} (${move})` : `${formatKpi(kpi, row.twinActual)} (${move})`;
}

export const NO_CHANGE_PLAN_NOTE = `This is not your twin. The no-change plan is ${NO_CHANGE_DEFINITION.charAt(0).toLowerCase()}${NO_CHANGE_DEFINITION.slice(1)} Your twin is ${TWIN_DEFINITION.charAt(0).toLowerCase()}${TWIN_DEFINITION.slice(1)}`;
